import { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ModalContext } from '../ModalContext'
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline'

import LoadingButton from 'components/LoadingButton'

export default function SendInviteModal() {

    const navigate = useNavigate()
    const { modalData, HideModal } = useContext(ModalContext)

    const requirePaymentMethodToInviteAthletes = useSelector((state) => state.user.requirePaymentMethodToInviteAthletes)
    const organizationAdminStripeCustomerId = useSelector((state) => state.user.organizationAdminStripeCustomerId)

    const [showCopiedTextConfirmation, setShowCopiedTextConfirmation] = useState(false)

    const [inputText, setInputText] = useState('')
    const [errorText, setErrorText] = useState('')

    const InviteMessageSection = () => (
        <div className="space-y-5">
            {/* Title */}
            <div className="text-center">
                <h2 className="text-lg font-semibold text-gray-900">{modalData.titleText}</h2>
                {modalData.bodyText && modalData.bodyText.length > 0 && (
                    <div className="mt-1 space-y-1">
                {modalData.bodyText.map((text, index) => (
                            <p key={index} className="text-sm text-gray-500">
                        {text}
                    </p>
                ))}
                    </div>
                )}
            </div>

            {/* Message Preview */}
            {modalData.messageText && (
                <div className="p-3 bg-gray-50 border border-gray-200 rounded-md">
                    <p className="text-xs font-medium text-gray-700 mb-2">Message Preview:</p>
                <div 
                        className="relative flex items-center px-4 py-3 bg-white border border-gray-200 rounded cursor-pointer hover:bg-gray-50 transition-colors"
                    onClick={handleCopyLink}
                >
                        <div className="flex-1 text-xs text-gray-600">
                        {modalData.messageText.split('\n').map((line, index) => (
                            <span key={index}>
                                {line}
                                <br />
                            </span>
                        ))}
                    </div>
                        {!showCopiedTextConfirmation && (
                            <DocumentDuplicateIcon className="h-5 w-5 text-gray-400 hover:text-gray-600 ml-2" />
                        )}
                        {showCopiedTextConfirmation && (
                            <div className="text-xs text-gray-600 font-medium ml-2">Copied!</div>
                        )}
                    </div>
                </div>
            )}

            {/* Input */}
            <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1.5">
                    {modalData.inviteType === 'invite-coach' ? 'Coach Email Address' : 'Athlete Email Address'}
                </label>
            <input
                type="email"
                name="email"
                id="email"
                    className="block w-full rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-gray-400 focus:border-transparent"
                    placeholder={modalData.inviteType === 'invite-coach' ? 'coach@example.com' : 'athlete@example.com'}
                value={inputText}
                onChange={(event) => setInputText(event.target.value)}
                autoFocus
            />
            </div>

            {/* Error Text */}
            {errorText !== '' && (
                <div className="rounded-md bg-red-50 p-3 border border-red-200">
                    <p className="text-sm text-red-800">{errorText}</p>
                </div>
            )}

            {/* Button */}
            <div className="flex justify-end pt-2">
            <LoadingButton
                buttonText={modalData.buttonText}
                action={OnSubmit}
                    className="inline-flex justify-center items-center gap-x-2 bg-orange-500 rounded-md text-white text-sm font-medium py-2 px-4 hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
            />  
            </div>
        </div>
    )

    const handleCopyLink = async () => {

        const copyMessage = modalData.messageText
        navigator.clipboard.writeText(copyMessage)

        setShowCopiedTextConfirmation(true)

        await new Promise(resolve => setTimeout(resolve, 1000))

        setShowCopiedTextConfirmation(false)

    }

    const OnNavigateToBilling = () => {
        navigate('/settings')
        HideModal()
    }

    const OnSubmit = () => {

        if (inputText === '') {
            setErrorText('Please enter a valid email address')
            return
        }

        modalData.buttonAction(inputText.trim())
        HideModal()

    }
    
    return (
        <>

            {/* Assessment Invite */}
            {modalData.inviteType === 'assessment' && <InviteMessageSection />}
            
            {/* Join Organization Invite */}
            {modalData.inviteType === 'join-organization' &&
                <>

                    {/* If require payment method to invite athletes, check if payment method is added */}
                    {requirePaymentMethodToInviteAthletes === 1 && 
                        <>

                            {/* If no payment method added */}
                            {organizationAdminStripeCustomerId === '' &&
                                <div className='space-y-5'>
                                    <div className="text-center">
                                        <h2 className="text-lg font-semibold text-gray-900">Please add a payment method to your account before inviting athletes</h2>
                                    </div>
                                    <div className="flex justify-center">
                                        <button
                                            onClick={OnNavigateToBilling}
                                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-orange-500 hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                                    >
                                        Go to Billing page
                                        </button>
                                    </div>
                                </div>
                            }

                            {/* If payment method added */}
                            {organizationAdminStripeCustomerId !== '' && 
                                <InviteMessageSection />
                            }

                        </>

                    }

                    {/* If not require payment method to invite athletes */}
                    {requirePaymentMethodToInviteAthletes === 0 && 
                        <InviteMessageSection />
                    }

                </>
            }

            {/* Invite Coach */}
            {modalData.inviteType === 'invite-coach' && <InviteMessageSection />}

        </>
    )
}
